<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DODN9L/tc-custom/9781473848351.jpg?1702412193830" alt="This image is the cover for the book Deborah and the War of the Tanks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deborah and the War of the Tanks
      </h1>
      <p class="bookDescription body article font2">
        <p>Deborah is a British First World War tank that rose from the grave after taking part in one of the most momentous battles in history. In November 1917 she played a leading role in the first successful massed tank attack at Cambrai. Eighty years later, in a remarkable feat of archaeology, the tanks buried remains were rediscovered and excavated, and are now preserved as a memorial to the battle and to the men who fought in it. John Taylors book tells the tale of the tank and her crew and tracks down their descendants to uncover a human story every bit as compelling as the military one.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Taylor
      </h2>
      
      <p class="authorDescription body article">John Taylor studied history at Cambridge University and has a lifelong interest in the First World War. He worked as a journalist for many years on national newspapers, TV and radio, before moving into the field of public relations, initially working on issues and crisis management and later as a communications director in the healthcare sector. Early retirement has given him the opportunity to write this book, which marks the culmination of a long-running project involving a dedicated team of researchers in Britain and France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?615b9061